var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    width: 40,
    height: 40,
    transform: "translate(-21554 -17133)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_48",
    "data-name": "Mask Group 48",
    transform: "translate(21554 17133)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ocean",
    transform: "translate(-21554 -17133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9850",
    "data-name": "Path 9850",
    d: "M40,20a19.91,19.91,0,0,1-2.3,9.316h0a34.254,34.254,0,0,1-35.4,0h0A19.91,19.91,0,0,1,0,20q0-.9.078-1.787a0,0,0,0,0,0,0q.086-.966.262-1.9v0a20,20,0,0,1,37.028-6.228A19.905,19.905,0,0,1,40,20Z",
    fill: "#fde05d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17744",
    "data-name": "Group 17744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9851",
    "data-name": "Path 9851",
    d: "M40,20a19.91,19.91,0,0,1-2.3,9.316h0a34.254,34.254,0,0,1-35.4,0h0A19.91,19.91,0,0,1,0,20q0-.9.078-1.787a0,0,0,0,0,0,0l.2-.056a.967.967,0,0,0,.058-1.847v0a19.855,19.855,0,0,1,2.291-6.228,20.006,20.006,0,0,0,34.738,0A19.905,19.905,0,0,1,40,20Z",
    fill: "#ffc300"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17751",
    "data-name": "Group 17751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9852",
    "data-name": "Path 9852",
    d: "M26.861,27.223A6.861,6.861,0,1,1,20,20.363,6.861,6.861,0,0,1,26.861,27.223Z",
    fill: "#ff9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9853",
    "data-name": "Path 9853",
    d: "M26.861,27.223A6.861,6.861,0,0,1,20,34.084V20.363A6.86,6.86,0,0,1,26.861,27.223Z",
    fill: "#ec781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9854",
    "data-name": "Path 9854",
    d: "M37.7,29.316a20.082,20.082,0,0,1-7.812,8.07l-5.905,1.561a18.056,18.056,0,0,1-8.033.272l-3.423-.661A20.062,20.062,0,0,1,2.3,29.316l17.668.919Z",
    fill: "#fe3345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9855",
    "data-name": "Path 9855",
    d: "M37.7,29.316a20.082,20.082,0,0,1-7.812,8.07l-5.905,1.561A18.1,18.1,0,0,1,20,39.535v-9.81Z",
    fill: "#de1263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9856",
    "data-name": "Path 9856",
    d: "M29.891,37.386A19.9,19.9,0,0,1,20,40h-.065a19.935,19.935,0,0,1-7.405-1.442,2.33,2.33,0,0,1,.756-1.009,4.012,4.012,0,0,1,2.325-.695,2.57,2.57,0,0,0,.747-.085.714.714,0,0,0,.5-.514.7.7,0,0,0-.314-.648c-.25-.181-.643-.169-.7-.522a.756.756,0,0,1,.491-.75,2.6,2.6,0,0,1,1.027-.1,1.473,1.473,0,0,0,.985-.254.829.829,0,0,0,.283-.7c-.059-.585-.537-.711-1.034-.685a1.626,1.626,0,0,1-.745-.076.548.548,0,0,1-.345-.6.657.657,0,0,1,.4-.377,2.478,2.478,0,0,0,.513-.238.755.755,0,0,0,.227-.846c-.125-.334-.475-.413-.795-.463a1.948,1.948,0,0,1-.723-.2.585.585,0,0,1-.3-.477h5.271a.8.8,0,0,0-.09.23.9.9,0,0,0,.553,1.008,3.923,3.923,0,0,0,.9.091c.3.036.635.219.656.521.031.448-.61.67-.7,1.11-.076.371.286.7.651.8s.759.068,1.119.186.694.488.567.845c-.171.481-.977.478-1.135.963a.645.645,0,0,0,.339.711,1.74,1.74,0,0,0,.827.166,12.075,12.075,0,0,1,3.478.3,3.331,3.331,0,0,1,1.617,1.141Z",
    fill: "#ffc300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9857",
    "data-name": "Path 9857",
    d: "M29.891,37.386A19.9,19.9,0,0,1,20,40V29.316h1.105a.8.8,0,0,0-.09.23.9.9,0,0,0,.553,1.008,3.923,3.923,0,0,0,.9.091c.3.036.635.219.656.521.031.448-.61.67-.7,1.11-.076.371.286.7.651.8s.759.068,1.119.186.694.488.567.845c-.171.481-.977.478-1.135.963a.645.645,0,0,0,.339.711,1.74,1.74,0,0,0,.827.166,12.075,12.075,0,0,1,3.478.3,3.331,3.331,0,0,1,1.617,1.141Z",
    fill: "#ff9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9858",
    "data-name": "Path 9858",
    d: "M37.7,29.316l-1.595.43a61.867,61.867,0,0,1-13.378,2.07q-1.364.061-2.73.061-1.711,0-3.422-.1A61.831,61.831,0,0,1,3.892,29.745L2.3,29.316H15.841l2.77.469,2.5-.469Z",
    fill: "#ff6378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9859",
    "data-name": "Path 9859",
    d: "M37.7,29.316l-1.595.43a61.867,61.867,0,0,1-13.378,2.07q-1.364.061-2.73.061l1.051-2.561Z",
    fill: "#fe3345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9860",
    "data-name": "Path 9860",
    d: "M22.73,31.816q-1.364.061-2.73.061-1.711,0-3.422-.1a.806.806,0,0,1,.332-.243,2.478,2.478,0,0,0,.513-.238.755.755,0,0,0,.227-.846c-.125-.334-.475-.413-.795-.463a1.948,1.948,0,0,1-.723-.2.585.585,0,0,1-.3-.477h5.271a.8.8,0,0,0-.09.23.9.9,0,0,0,.553,1.008,3.923,3.923,0,0,0,.9.091c.3.036.635.219.656.521.019.266-.2.452-.4.65Z",
    fill: "#ffeb98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9861",
    "data-name": "Path 9861",
    d: "M22.73,31.816q-1.364.061-2.73.061V29.316h1.105a.8.8,0,0,0-.09.23.9.9,0,0,0,.553,1.008,3.923,3.923,0,0,0,.9.091c.3.036.635.219.656.521.019.266-.2.452-.4.65Z",
    fill: "#f9e073"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17745",
    "data-name": "Group 17745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9862",
    "data-name": "Path 9862",
    d: "M13.828,18.18c0,.01,0,.02,0,.03H.079q.086-.966.262-1.9c.066-.005.133-.008.2-.008a2.457,2.457,0,0,1,.358.026A4.439,4.439,0,0,1,9.136,15a3.422,3.422,0,0,1,4.692,3.177Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9863",
    "data-name": "Path 9863",
    d: "M10.489,18.211c0-.006,0-.012,0-.018a1.968,1.968,0,0,0-2.7-1.827,2.553,2.553,0,0,0-4.737.761,1.435,1.435,0,0,0-1.6,1.084h9.036Z",
    fill: "#dff7fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17746",
    "data-name": "Group 17746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9864",
    "data-name": "Path 9864",
    d: "M38.895,23.633c0-.006,0-.013,0-.019a2.153,2.153,0,0,0-2.952-2,2.793,2.793,0,0,0-5.183.832,1.571,1.571,0,0,0-1.752,1.186Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9865",
    "data-name": "Path 9865",
    d: "M36.794,23.633s0-.007,0-.011a1.238,1.238,0,0,0-1.7-1.15,1.606,1.606,0,0,0-2.98.479.917.917,0,0,0-.129-.009.9.9,0,0,0-.878.692Z",
    fill: "#dff7fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17747",
    "data-name": "Group 17747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9866",
    "data-name": "Path 9866",
    d: "M37.228,9.838H18.442A3.062,3.062,0,0,1,21.417,7.5a3.111,3.111,0,0,1,.438.032,5.44,5.44,0,0,1,10.1-1.621,4.173,4.173,0,0,1,1.557-.3c.134,0,.266.006.4.019a20,20,0,0,1,3.324,4.213Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9867",
    "data-name": "Path 9867",
    d: "M33.609,9.838c0-.007,0-.014,0-.022A2.412,2.412,0,0,0,30.3,7.577a3.128,3.128,0,0,0-5.805.932,1.759,1.759,0,0,0-1.963,1.329Z",
    fill: "#dff7fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17748",
    "data-name": "Group 17748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9868",
    "data-name": "Path 9868",
    d: "M30.437,15.077a1.545,1.545,0,0,0-2.316.957h-.537a1.544,1.544,0,0,0-2.315-.957,1.57,1.57,0,0,1,.222-.28,1.547,1.547,0,0,1,2.362.212,1.5,1.5,0,0,1,.177-.212,1.547,1.547,0,0,1,2.406.28Z",
    fill: "#605f74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9869",
    "data-name": "Path 9869",
    d: "M30.437,15.077a1.545,1.545,0,0,0-2.316.957h-.268V15.008a1.5,1.5,0,0,1,.177-.212,1.547,1.547,0,0,1,2.406.28Z",
    fill: "#58586b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17749",
    "data-name": "Group 17749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9870",
    "data-name": "Path 9870",
    d: "M13.073,20.95a1.545,1.545,0,0,0-2.316.957H10.22a1.544,1.544,0,0,0-2.315-.957,1.57,1.57,0,0,1,.222-.28,1.547,1.547,0,0,1,2.362.212,1.5,1.5,0,0,1,.177-.212,1.547,1.547,0,0,1,2.406.28Z",
    fill: "#605f74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9871",
    "data-name": "Path 9871",
    d: "M13.073,20.95a1.545,1.545,0,0,0-2.316.957h-.268V20.881a1.5,1.5,0,0,1,.177-.212,1.547,1.547,0,0,1,2.406.28Z",
    fill: "#58586b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17750",
    "data-name": "Group 17750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9872",
    "data-name": "Path 9872",
    d: "M16.412,10.147A1.545,1.545,0,0,0,14.1,11.1h-.537a1.544,1.544,0,0,0-2.315-.957,1.57,1.57,0,0,1,.222-.28,1.547,1.547,0,0,1,2.362.212,1.5,1.5,0,0,1,.177-.212,1.547,1.547,0,0,1,2.406.28Z",
    fill: "#605f74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9873",
    "data-name": "Path 9873",
    d: "M16.412,10.147A1.545,1.545,0,0,0,14.1,11.1h-.268V10.078a1.5,1.5,0,0,1,.177-.212,1.547,1.547,0,0,1,2.406.28Z",
    fill: "#58586b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9874",
    "data-name": "Path 9874",
    d: "M35.33,17.059a13.664,13.664,0,0,1-1.826-.082c-.331-.028-.711-.035-.9-.36a.547.547,0,0,1,.165-.733,1.406,1.406,0,0,1,.549-.209,7.385,7.385,0,0,1,2.641-.076,1.551,1.551,0,0,1,.591.183.611.611,0,0,1,.311.507C36.845,16.843,36.118,17.022,35.33,17.059Z",
    fill: "#fff9bb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodEvening);
export default __webpack_public_path__ + "static/media/good-evening.7a1b9cd8e49522881c861dc3e122f843.svg";
export { ForwardRef as ReactComponent };